import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'basic', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/basic.js').default) });
app.model({ namespace: 'feedback', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/feedback.js').default) });
app.model({ namespace: 'global', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/global.js').default) });
app.model({ namespace: 'info', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/info.js').default) });
app.model({ namespace: 'multiFake', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/multiFake.js').default) });
app.model({ namespace: 'multiParent', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/multiParent.js').default) });
app.model({ namespace: 'newShop', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/newShop.js').default) });
app.model({ namespace: 'parent', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/parent.js').default) });
app.model({ namespace: 'poi', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/poi.js').default) });
app.model({ namespace: 'qualification', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/qualification.js').default) });
app.model({ namespace: 'releaseBeforeAudit', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/releaseBeforeAudit.js').default) });
app.model({ namespace: 'reportService', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/reportService.js').default) });
app.model({ namespace: 'setting', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/setting.js').default) });
app.model({ namespace: 'shoplog', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/shoplog.js').default) });
app.model({ namespace: 'shopTag', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/shopTag.js').default) });
app.model({ namespace: 'specialBusinessTime', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/specialBusinessTime.js').default) });
app.model({ namespace: 'success', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/success.js').default) });
app.model({ namespace: 'user', ...(require('/opt/jenkins/workspace/dianpingpoi-data-center-fe-portal-production/src/models/user.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
